export default defineNuxtPlugin(() => {
  if (process.client) {
    const impressions = useImpressions()
    impressions.init()
    
    // Для удобства отладки добавляем в window
    if (process.dev) {
      // @ts-ignore
      window.impressions = impressions
    }
  }
})